// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ZoomOutIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ZoomOutIcon" ref={forwardedRef} {...props}>
      <path d="M11.526 12.855a6 6 0 1 1 1.4-1.429l3.817 3.817a1 1 0 1 1-1.415 1.414zM12.5 8a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0" />
      <path d="M10.75 8.75h-5.5v-1.5h5.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ZoomOutIcon = /* @__PURE__ */ Object.assign(ZoomOutIconComponent, {
  displayName: 'ZoomOutIcon',
});
